// @flow
import React from 'react';
import {
  NavLink,
  withRouter,
} from 'react-router-dom';
import classNames from 'classnames';
import './CustomerNavbar.css';
import logo from '../../assets/logo.png';
import {DEMO} from '../../roles';

export type Props = {
  history: Object,
  pathname: string,
  showMenu: boolean,
  toggleMenu: Function,
  onLogoutClick: Function,
  userRole: number,
};

const CustomerNavbar = ({pathname, showMenu, toggleMenu, onLogoutClick, history, userRole}: Props) => (
  <div className="CustomerNavbar">
    <div className="row fill-height">
      <div className="column">
        <div className="CustomerNavbar-menu">
          <div
            className="CustomerNavbar-menu-toggle show-for-small-only"
            onClick={() => toggleMenu(!showMenu)}>
            <i className="fa fa-bars" />
          </div>
          <a
            href=""
            onClick={evt => {evt.preventDefault(); history.push(`${pathname}/`);}}
            className="CustomerNavbar-logo">
            <img
              src={logo}
              alt="Hökerum" />
          </a>
          <div
            className={classNames({
              'CustomerNavbar-navigation': true,
              'hide-for-small-only': !showMenu,
            })}>
            <NavLink
              to={`${pathname}/`}
              className="CustomerNavbar-item"
              activeClassName="active"
              exact>
              <div className="CustomerNavbar-item-label">
                Hem
              </div>
            </NavLink>
            <NavLink
              to={`${pathname}/order`}
              className="CustomerNavbar-item"
              activeClassName="active">
              <div className="CustomerNavbar-item-label">
                Mina tillval
              </div>
            </NavLink>
            { userRole !== DEMO &&
              <NavLink
                to={`${pathname}/files`}
                className="CustomerNavbar-item"
                activeClassName="active">
                <div className="CustomerNavbar-item-label">
                Mina filer
                </div>
              </NavLink>
            }
            <a
              href=""
              onClick={evt => {evt.preventDefault(); onLogoutClick();}}
              className="CustomerNavbar-item">
              <div className="CustomerNavbar-item-label">
                Logga ut
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default withRouter(CustomerNavbar);



// WEBPACK FOOTER //
// ./src/components/CustomerNavbar/CustomerNavbar.js